import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "zh", setLang: () => {} });
export const useLang = () => useContext(LangContext);
